import { CreateWorkerButton } from "#src/batteries-included-components/Buttons/CreateWorkerButton/CreateWorkerButton";
import { CreateWorkerDialog } from "#src/batteries-included-components/Dialogs/CreateWorkerDialog";
import { useListWorkers } from "#src/components/hooks/adapters/useWorkers";
import { useIsFeatureAvailable } from "#src/contexts/AuthenticatedContext.helpers";
import { useBreadcrumbsFromRoute } from "#src/utils/route";
import { Page, Tooltip } from "@validereinc/common-components";
import { MAX_WORKER_COMPANY_LIMIT } from "@validereinc/domain";
import { FeatureFlags, PermissionsMap } from "@validereinc/domain-controllers";
import React, { useState } from "react";
import { WorkerVersionsRoutePath } from ".";
import { WorkersTablePanel } from "./WorkersTablePanel";

const TOOLTIP_CONTENT =
  "You have reached the maximum number of workers for your company. Please delete existing workers to create a new one.";

export const WorkersPage = () => {
  const [breadcrumbs] = useBreadcrumbsFromRoute(WorkerVersionsRoutePath);

  const [hasWorkerWritePermission] = useIsFeatureAvailable({
    featureFlagQuery: FeatureFlags.CustomCodeFeatureFlag,
    permissionQuery: PermissionsMap.WorkerWrite,
  });

  const [isCreateWorkerDialogOpen, setIsCreateWorkerDialogOpen] =
    useState<boolean>(false);

  const { data: workersData, isLoading: isLoadingWorkers } = useListWorkers({});
  const workers = workersData?.data ?? [];

  const onOpenCreateWorkerDialog = () => setIsCreateWorkerDialogOpen(true);
  const onCloseCreateWorkerDialog = () => setIsCreateWorkerDialogOpen(false);

  const isLoading = isLoadingWorkers;
  const hasCompanyReachedMaximumWorkers = Boolean(
    workers.length >= MAX_WORKER_COMPANY_LIMIT
  );

  return (
    <Page
      title={WorkerVersionsRoutePath.title}
      breadcrumbs={breadcrumbs}
      isLoading={isLoading}
      actionRow={[
        ...(hasWorkerWritePermission
          ? [
              !isLoading && hasCompanyReachedMaximumWorkers ? (
                <Tooltip
                  key="create-worker-button-tooltip"
                  content={TOOLTIP_CONTENT}
                >
                  <CreateWorkerButton
                    isLoading={isLoading}
                    onClick={onOpenCreateWorkerDialog}
                    isDisabled={hasCompanyReachedMaximumWorkers}
                  />
                </Tooltip>
              ) : (
                <CreateWorkerButton
                  isLoading={isLoading}
                  onClick={onOpenCreateWorkerDialog}
                  isDisabled={hasCompanyReachedMaximumWorkers}
                />
              ),
            ]
          : []),
      ]}
    >
      <WorkersTablePanel />
      <CreateWorkerDialog
        isOpen={isCreateWorkerDialogOpen}
        onClose={onCloseCreateWorkerDialog}
      />
    </Page>
  );
};
